module.exports = __webpack_public_path__ + "img/sea-6.c3881dc0.jpg";